import { createContext } from 'react';
import {
    QUERY_KEYS_IGD,
    useChartsData
} from '../../../../Common/hooks/useChartsData';
import { useIgdFiltersContext } from '../../../Common/Filters/hooks/useIgdFiltersContext';

export const CadUniqueChartsDataContext = createContext();

const CadUniqueChartsDataProvider = ({ children }) => {
    const { filters } = useIgdFiltersContext();
    const filterParams = {
        year: filters?.year?.value ?? '',
        month: filters?.month?.value ?? '',
        location: filters.unidade.value,
        city: filters.cidade?.value,
    };

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_IGD.FAMILIES_CAD_UN,
            url: 'governanceroom/socialdashboard/cadUn/families',
        },
        filterParams
    );

    const peopleData = useChartsData(
        {
            key: QUERY_KEYS_IGD.PEOPLE_DATA_CAD_UN,
            url: 'governanceroom/socialdashboard/cadUn/people',
        },
        filterParams
    );

    const avgPeoplePerFamilyData = useChartsData(
        {
            key: QUERY_KEYS_IGD.AVERAGE_PEOPLE_PER_FAMILY_CAD_UN,
            url: 'governanceroom/socialdashboard/cadUn/averagePeoplePerFamily',
        },
        filterParams
    );

    const chartData = {
        familiesAnual: data?.anualEvolution ?? [],
        familiesMonth: data?.monthEvolution ?? [],
        peopleAnual: peopleData?.data?.anualEvolution ?? [],
        peopleMonth: peopleData?.data?.monthEvolution ?? [],
        avgPeoplePerFamilyAnual: avgPeoplePerFamilyData?.data?.anualEvolution ?? [],
        avgPeoplePerFamilyMonth: avgPeoplePerFamilyData?.data?.monthEvolution ?? []
    };

    return (
        <CadUniqueChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </CadUniqueChartsDataContext.Provider>
    );
};

export default CadUniqueChartsDataProvider;
